import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Allocation: Represents the assignment of an employee to a project for a specific time period, detailing the percentage of their time allocated to that project.',
    name: 'Allocations',
    partialId: PartialId.Standard.create('allocations'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
